exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  width: 100%;\n  /* .search-input {\r\n\r\n    } */ }\n\n.mat-row:hover {\n  background-color: rgba(52, 152, 219, 0.11); }\n  .mat-row:hover .table-buttons button {\n    opacity: 1; }\n\n.mat-row .table-buttons {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end; }\n  .mat-row .table-buttons button {\n    opacity: 0;\n    transition: all 0.2s ease-in-out; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/components/app-users/app-users.component.scss
// module id = ../../../../../src/app/components/app-users/app-users.component.scss
// module chunks = main